import { designTokens } from "@itandi/itandi-bb-ui";
import { Grid } from "@itandi/itandi-bb-ui/Grid";
import { HorizontalStepBar } from "@itandi/itandi-bb-ui/HorizontalStepBar";
import type { Status } from "~/models/Status";

type Props = {
	currentStatusId: number | null;
	statuses: Status[];
};

export function StatusBar({ currentStatusId, statuses }: Props) {
	const displayStatuses = statuses.filter((s: Status) => s.statusBarDisplay);
	const labels = displayStatuses.map((status) => status.name);
	const index =
		currentStatusId === null
			? -1
			: displayStatuses.findIndex((status) => status.id === currentStatusId);

	return (
		<Grid my={designTokens["spacing/s"]}>
			<HorizontalStepBar index={index} labels={labels} />
		</Grid>
	);
}
